import { ConnectPaymentDetails } from '@stripe/react-connect-js';
import { useToast } from '@televet/kibble-ui/build/components/Toast';
import React from 'react';

interface DisputeDrawerProps {
  stripeId: string;
  onClose: () => void;
  setIsDisputeDrawerLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DisputeDrawer = ({ stripeId, onClose, setIsDisputeDrawerLoading }: DisputeDrawerProps): JSX.Element => {
  const toast = useToast();

  return (
    <ConnectPaymentDetails
      payment={stripeId}
      onClose={onClose}
      onLoaderStart={(): void => setIsDisputeDrawerLoading(false)}
      onLoadError={({ error }): void => {
        toast({
          title: error.message || 'Error loading dispute information',
          description: 'Please refresh the page and try again.',
          status: 'error',
        });
        setIsDisputeDrawerLoading(false);
      }}
    />
  );
};
